module.exports = __webpack_public_path__ + "static/media/55.f6803974.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/55.svg
// module id = 181
// module chunks = 0